import React, { useState } from 'react';
// import { useParams } from 'react-router-dom';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Share, WhatsApp, Twitter, Facebook, LinkedIn, ContentCopy } from '@mui/icons-material';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from 'react-share';
import useNewsItem from '../../hooks/useNewsItem';


const ShareOption = () => {
    // const { id } = useParams();
    const [shareOptionsVisible, setShareOptionsVisible] = useState(false);
    const [showCopyMessage, setShowCopyMessage] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);

    const newsItem = useNewsItem();

    const handleShareClick = () => {
        setShareOptionsVisible(!shareOptionsVisible);
        setShowCopyMessage(true);
        setLinkCopied(false); // Reset copied status on new click
    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareUrl).then(() => {
            setLinkCopied(true);
            setTimeout(() => {
                setShowCopyMessage(false);
                setLinkCopied(false);
            }, 2000);
        }).catch((err) => {
            console.error('Failed to copy: ', err);
        });
    };

    // You should check if newsItem is not null before trying to access its properties.
    const shareUrl = window.location.href;
    const title = newsItem ? newsItem.title : 'Default Title';

    // const shareUrl = window.location.href;
    // const title = newsItem.title;


    // Social media platforms with their corresponding components and icons
    const socialMediaPlatforms = [
        { name: 'WhatsApp', component: WhatsappShareButton, icon: WhatsApp },
        { name: 'Twitter', component: TwitterShareButton, icon: Twitter },
        { name: 'Facebook', component: FacebookShareButton, icon: Facebook },
        { name: 'LinkedIn', component: LinkedinShareButton, icon: LinkedIn },
    ];

    const iconStyles = {
        WhatsApp: {
            color: "#25D366",
        },
        Twitter: {
            color: "#1DA1F2",
        },
        Facebook: {
            color: "#1877F2",
        },
        LinkedIn: {
            color: "#0077b5",
        },
    };

    return (
        <Box sx={{ backgroundColor: '#f5f5f5', textAlign: 'center', mt: 2, pb: 3 }}>
            <Box>
                <IconButton onClick={handleShareClick}>
                    <Share />
                </IconButton>
                <Typography variant="caption" component="span" sx={{ verticalAlign: 'sub' }}>
                    Share
                </Typography>
            </Box>

            {shareOptionsVisible && (
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
                    {socialMediaPlatforms.map((platform) => {
                        const ShareComponent = platform.component;
                        const Icon = platform.icon;
                        return (
                            <ShareComponent key={platform.name} url={shareUrl} title={title}>
                                <IconButton>
                                    <Icon style={iconStyles[platform.name]} />
                                </IconButton>
                            </ShareComponent>
                        );
                    })}
                </Box>
            )}

            {showCopyMessage && (
                <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <Button
                        onClick={handleCopyLink}
                        sx={{
                            color: 'white',
                            backgroundColor: '#484848',
                            '&:hover': {
                                backgroundColor: '#5e5e5e',
                            },
                            transition: 'background-color 0.3s ease-in-out',
                            '&:active': {
                                backgroundColor: 'black',
                            },
                            '&:focus': {
                                boxShadow: 'none',
                            },
                        }}
                    >
                        {linkCopied ? 'Link Copied' : 'Click to Copy Link'}
                        <ContentCopy sx={{ ml: 1 }} />
                    </Button>
                </Box>
            )}
        </Box>
    );

};

export default ShareOption;               